import React from 'react';
import PropTypes from 'prop-types';

import styles from 'styles/_colors.css'; 

const loadFile = (name, size) => require(`assets/svgs/illustrations/${size}/${name}.svg`);

const Illustration = ({
  color = styles['red'],
  customClasses,
  height,
  name,
  size = 120,
  width,
  ...rest
}) => {
  const w = width || size;
  const h = height || size;

  loadFile(name, size);

  return (
    <svg className={customClasses} width={w} height={h} {...rest}>
      <use xlinkHref={`#${name}`} fill={ color } />
    </svg>
  );
};

Illustration.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  customClasses: PropTypes.string,
  width: PropTypes.number,
};

Illustration.displayName = 'Illustration';

export default Illustration;



// WEBPACK FOOTER //
// ./src/uis/foundations/Illustrations/Illustration.js